<script>
  import Link from "@components/Link.svelte"

  let className
  export { className as class }
</script>

<div class="flex text-neutral-500 text-sm items-center {className}">
  Includes standard shipping fee
  <Link href="https://support.onsidedoor.com/en/articles/2016065" external class="[ ml-1 ]">
    <span class="[ sr-only ]">About SideDoor's Shipping</span>
    <svg xmlns="http://www.w3.org/2000/svg" class="[ h-4 w-4 ]" fill="currentColor" viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm2-1.645A3.502 3.502 0 0 0 12 6.5a3.501 3.501 0 0 0-3.433 2.813l1.962.393A1.5 1.5 0 1 1 12 11.5a1 1 0 0 0-1 1V14h2v-.645z"
      />
    </svg>
  </Link>
</div>
